import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TagTemplatesDaoService } from './dao/tag-templates-dao.service';
import { TagTemplateDbTableDefinition } from './dao/tag-templates-dao/tag-template-db-table-definition';
import { TagTemplatesDbDaoService } from './dao/tag-templates-dao/tag-templates-db-dao.service';
import { TagTemplatesService } from './logic/tag-templates.service';
import { TagTemplatesLogicService } from './logic/tag-templates/tag-templates-logic.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: TagTemplatesService, useClass: TagTemplatesLogicService },
    { provide: TagTemplatesDaoService, useClass: TagTemplatesDbDaoService },
    { provide: TagTemplateDbTableDefinition },
  ],
})
export class TagTemplatesModule {}
